<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}">
</ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>

    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.STATIC_PAGE'"> </span></div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="" aria-current="page"> <a (click)="service.back()" href="javascript:void(0);" class="back-ic-btn"><i class="bx bx-chevron-left"></i> </a></li>
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <!--end breadcrumb-->

            <div class="row">
                <div class="col-xl-7 mx-auto">
                    <div class="card border-top border-0 border-4 border-brand">
                        <div class="card-body p-5">
                            <div class="card-title d-flex align-items-center">
                                <div><i class="bx bxs-user me-1 font-22 brand-color"></i>
                                </div>
                                <h5 class="mb-0"><span [translate]="'GREATER.STATIC_PAGE'"> </span></h5>
                            </div>
                            <hr>
                            <div class="custom-form">
                                <form [formGroup]="staticData">

                                    <div class="col-md-12 pb-3">
                                        <label for="inputFirstName" class="form-label"><span [translate]="'GREATER.TITLE'"> </span></label>
                                        <input type="email" class="form-control" id="inputFirstName" [(ngModel)]="CurrentDetail.title" [ngModelOptions]="{standalone: true}" readonly disabled>
                                    </div>

                                    <div class="col-md-12">
                                        <label for="inputLastName" class="form-label"><span [translate]="'GREATER.DESCRIPTION'"> </span></label>
                                        <ckeditor [(ngModel)]="CurrentDetail.description" formControlName="description" [ngClass]="{ 'is-invalid': submitted && f.description.errors }" ngDefaultControl></ckeditor>
                                        <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                            <span [translate]="'GREATER.DESCRIPTION_IS_REQUIRED'"> </span>
                                        </div>
                                    </div>
                                    <div class="form-btn-box pt-4 col-12 d-flex">
                                        <button type="click" class="btn custom-btn gradient1-btn px-5 me-5" (click)="service.back()"><span [translate]="'GREATER.BACK'"> </span>
                                        </button>
                                        <button type="submit" class="btn custom-btn gradient1-btn px-5" (click)="Onsubmit()"><span [translate]="'GREATER.UPDATE'"> </span></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end row-->

        </div>
    </div>

    <app-footer></app-footer>
</div>